/**
 * Voice Library - ElevenLabs Voice Definitions
 *
 * Using ElevenLabs default/premade voices (always available).
 */

export interface VoiceSettings {
  stability: number;
  similarity_boost: number;
  style?: number;
}

export interface Voice {
  id: string;
  name: string;
  settings: VoiceSettings;
}

export const VOICES: Record<string, Voice> = {
  // NARRATOR - Daniel: British, authoritative, clear
  narrator: {
    id: "cjVigY5qzO86Huf0OWal",
    name: "Ship Computer",
    settings: { stability: 0.5, similarity_boost: 0.75, style: 0.3 },
  },

  // GRUFF MALE - Brian: American, deep (traders, dock workers)
  npc_male_gruff: {
    id: "N2lVS1w4EtoT3dr4eOWO",
    name: "Gruff Male",
    settings: { stability: 0.4, similarity_boost: 0.7, style: 0.4 },
  },

  // POSH MALE - George: British, refined (officials, bureaucrats)
  npc_male_posh: {
    id: "JBFqnCBsd6RMkjVDRZzb",
    name: "Posh Male",
    settings: { stability: 0.6, similarity_boost: 0.8, style: 0.2 },
  },

  // CASUAL MALE - Charlie: Australian (friendly NPCs)
  npc_male_casual: {
    id: "XB0fDUnXU5powFXDhCwa",
    name: "Casual Male",
    settings: { stability: 0.5, similarity_boost: 0.75, style: 0.3 },
  },

  // INTENSE MALE - Callum: Transatlantic (mercenaries, bounty hunters)
  npc_male_intense: {
    id: "IKne3meq5aSn9XLyUdCD",
    name: "Intense Male",
    settings: { stability: 0.35, similarity_boost: 0.65, style: 0.5 },
  },

  // PLEASANT FEMALE - Sarah: British, soft (station staff)
  npc_female_pleasant: {
    id: "EXAVITQu4vr4xnSDxMaL",
    name: "Pleasant Female",
    settings: { stability: 0.6, similarity_boost: 0.8, style: 0.2 },
  },

  // TOUGH FEMALE - Matilda: Australian (mercenaries)
  npc_female_tough: {
    id: "XrExE9yKIg1WjnnlVkGX",
    name: "Tough Female",
    settings: { stability: 0.45, similarity_boost: 0.7, style: 0.4 },
  },

  // PIRATE - Callum with aggressive settings
  pirate: {
    id: "IKne3meq5aSn9XLyUdCD",
    name: "Pirate",
    settings: { stability: 0.25, similarity_boost: 0.6, style: 0.7 },
  },

  // STATION PA - George with monotone settings
  station_pa: {
    id: "JBFqnCBsd6RMkjVDRZzb",
    name: "Station PA",
    settings: { stability: 0.95, similarity_boost: 0.9, style: 0.0 },
  },
};

/**
 * Map NPC types to voice IDs
 */
export const NPC_TYPE_VOICES: Record<string, string> = {
  trader: "npc_male_gruff",
  merchant: "npc_male_gruff",
  pirate: "pirate",
  bounty_hunter: "npc_male_intense",
  patrol: "npc_male_posh",
  official: "npc_male_posh",
  quest_giver: "npc_male_casual",
  civilian: "npc_female_pleasant",
  mercenary: "npc_female_tough",
  bartender: "npc_male_casual",
  captain: "npc_male_intense",
};
